// extracted by mini-css-extract-plugin
export default {"imgdiv":"aca385a24f a064e03c98","img":"_00dc233c17 _7909faa4ea"};